// extracted by mini-css-extract-plugin
export default {"Winner":"GameResultText-module__Winner___i6nH","Loser":"GameResultText-module__Loser__Pr8ow"};